<template>
	<div style="display:flex">
		<div class="body-mid">
			<div style="background: #FFFFFF;padding: 20px;">
				<div class="body-mid-top">
					<div class="mid-top-left">
						<div @click="orderPaixu(1)">
							时间<img src="../../assets/images/shaixuan.png" alt="">
						</div>
						<div @click="orderPaixu(2)">
							关注量<img src="../../assets/images/shaixuan.png" alt="">
						</div>
					</div>
					<div class="mid-top-right">
						<div v-for="(item, index) in topType" :key="item.id" @click=" sendType(item.id)"
							:class="activeTopType == item.id ? 'activeTop' : ''">
							{{ item.name }}
						</div>
					</div>
				</div>
				<div class="body-mid-main" v-if="tableData.data">
					<div class="main-item" v-for="(item, index) in tableData.data" :key="item.id" @click='goWhere(item.id)'>
						<div class="main-item-pic">
							<img :src='getImgSrc(item.image)' alt="">
						</div>
						<div class="main-item-title" style=" overflow: hidden;
                          text-overflow: ellipsis;
						  width: 100%;
						  text-align: center;
                          max-height: calc(2em + 8px);">
							{{item.title}}
						</div>
					</div>
				</div>
				<div v-else>
					<p style="text-align: center;margin: 100px 0;" v-if="keyWord == ''">暂无数据</p>
					<p style="text-align: center;margin: 100px 0;" v-else>暂无关于“{{keyWord}}”的数据</p>
				</div>
				<div class="body-mid-footer" v-if=" tableData.current_page !== tableData.last_page & tableData.total !== 0" @click="loadingMore">
					加载更多<img src='../../assets/images/darrwo.png' alt="">
				</div>
			</div>
			<!-- <div class="page-last">
				<div class="page-last-top">
					<div class="page-last-title">
						为您推荐
					</div>
					<div class="huanyih" @click="changeGenius">
						换一批
					</div>
				</div>
				<div class="page-last-body">
					<div class="body-person">
						<div class="body-person-item" v-for="(item, index) in geniusList.data" :key="item.id" @click="$router.push(`geniusClub/geniusInfo?id=${1}`)">
							<div class="pgirl"
								style="width: 151px;height: 270px;display:flex;;padding-left:8px;box-sizing: border-box;align-items: center;justify-content: center;">
								<img :src='getImgSrc(item.avatar)' style="width: 100%;height: 100%;" alt="">
							</div>
							<div>
								<p>{{item.info_name || item.nickname}}</p>
								<p>{{item.school}}</p>
								<p>{{item.qualification}}</p>
							</div>
						</div>

					</div>
				</div>
			</div> -->
		</div>
		<div class="body-right">
			<div @click="dialogVisible = true">
				<img src='../../assets/images/zhifly.png' alt="" style="width: 18px;height: 18px;"><span>发布</span>
			</div>
			<div @click="dialogVisible2 = true" style="background: #0297F8;">
				<img src='../../assets/images/dwen.png' alt="" style="width: 19px;height: 19px;"><span>求助</span>
			</div>
			<div @click="dialogVisible3 = true" style="background:#EEA800;">
				<img src='../../assets/images/ligth.png' alt="" style="width: 14px;height: 18px;"><span>应助</span>
			</div>

		</div>
		<el-dialog title="请选择栏目" :visible.sync="dialogVisible" center width="700px" top="40vh" :lock-scroll="false">
			<div style="display:flex;justify-content: space-around;font-size: 18px;color: black;">
				<div @click="goto(`/projectNeed/releaseNeed`)"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
					项目需求池
				</div>
				<div @click="goto(`/zyTools/createTools`)"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
					资源工具池
				</div>
				<div @click="goto(`/solutionDetail/releaseSolution`)"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
					解决方案池
				</div>
				<div @click="goto(`/productService/createProductService`)"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height:47px;text-align: center;cursor: pointer;">
					产品服务池
				</div>
			</div>

		</el-dialog>
		<el-dialog title="请选择栏目" :visible.sync="dialogVisible2" center width="700px" top="40vh" :lock-scroll="false">
			<div style="display:flex;justify-content: space-around;font-size: 18px;color: black;">
				<div @click="goto(`/zyTools/createTools`)"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
					资源工具池
				</div>
				<div @click="goto(`/solutionDetail/createQz`)"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
					解决方案池
				</div>
				<div @click="goto(`/productService/proCreateQz`)"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height:47px;text-align: center;cursor: pointer;">
					产品服务池
				</div>
			</div>

		</el-dialog>
		<el-dialog title="请选择栏目" :visible.sync="dialogVisible3" center width="700px" top="40vh" :lock-scroll="false">
			<div style="display:flex;justify-content: space-around;font-size: 18px;color: black;">
				<div @click="goto(`/allsearchRefine/xmxqC`)"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
					项目需求池
				</div>
				<div @click="goto(`/ResourceTools/helpList`)"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
					资源工具池
				</div>
				<div @click="goto(`/searchIndex/solutionHelpList`)"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
					解决方案池
				</div>
				<div @click="goto(`/searchIndex/proHelpList`)"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height:47px;text-align: center;cursor: pointer;">
					产品服务池
				</div>
			</div>

		</el-dialog>
	</div>
</template>
<script>
	export default {
		props: {
			checked: {
				type: Object
			},
			keyWord: {
				type: String
			}
		},
		data() {
			return {
				dialogVisible: false,
				dialogVisible2: false,
				dialogVisible3: false,
				activeTopType: 2,
				topType: [
					// {
					// 		id: 1,
					// 		name: '全部'
					// },
					{
						id: 2,
						name: '解决方案'
					},
					{
						id: 3,
						name: '项目需求'
					},
					{
						id: 4,
						name: '资源工具'
					},
					{
						id: 5,
						name: '产品服务'
					},
				],
				geniusList: [],
				geniusCurrent: 1,
				shaiXuan:{
					tags:[],
					subjectcate_ids:[],
					industry_ids:[],
					stage_ids:[],
					status:'',
					keywords:'',
					type:1,
					page:1,
					order:''
				},
				tableData:''
			}
		},
		watch:{
			checked:{
				handler(newValue,oldValue){
					this.shaiXuan.subjectcate_ids = newValue.checkedXK
					this.shaiXuan.tags = newValue.checkedJL
					this.shaiXuan.industry_ids = newValue.checkedHY
					this.shaiXuan.stage_ids = newValue.checkedJD
					this.getList()
					console.log('check');
				},
				deep: true,
			},
			keyWord:{
				handler(newValue,oldValue){    
					this.shaiXuan.keywords = newValue
					this.getList()
					console.log('key');
				},
			},
		},
		created() {
			this.getGeniusList()
			this.getList()
		},
		methods: {
			async getList(){
				let list;
				if(this.$route.query.type == 'tags'){
					this.shaiXuan.tags = [this.$route.query.tags]
					list =await this.$api.productServeList({...this.shaiXuan})
					this.activeTopType = 5
					this.tableData = list.data
					this.$route.query.type = ''
				}
				// else if(this.activeTopType == 1){
				// 	list =await this.$api.schemehelpListall({...this.shaiXuan})
				// 	this.tableData = list
				// 	console.log('全部数据：',this.tableData);
				// }
				else if(this.activeTopType == 2){
					list =await this.$api.schemehelpList({...this.shaiXuan})
					this.tableData = list.data
				}else if(this.activeTopType == 3){
					list =await this.$api.projectneedList({...this.shaiXuan})
					this.tableData = list.data
				}else if(this.activeTopType == 4){
					list =await this.$api.InstrumentList({...this.shaiXuan})
					this.tableData = list.data
				}else if(this.activeTopType == 5){
					list =await this.$api.productServeList({...this.shaiXuan})
					this.tableData = list.data
				}

			},
			loadingMore(){
				this.shaiXuan.page++
				this.getList()
			},
			goWhere(id){
				if(this.activeTopType == 2){
					this.$router.push(`/solutionDetail?id=${id}`)
				}else if(this.activeTopType == 3){
					this.$router.push(`/projectNeedDetail?id=${id}`)
				}else if(this.activeTopType == 4){
					this.$router.push(`/zyTools/zyQiuzDetail?id=${id}`)
				}else if(this.activeTopType == 5){
					this.$router.push(`/productService?id=${id}`)
				}
			},
			orderPaixu(order){
				if(order == 1){
					this.shaiXuan.order == 'id desc' ? this.shaiXuan.order = 'id asc' : this.shaiXuan.order = 'id desc'
				}else{
					this.shaiXuan.order == 'collect_num desc' ? this.shaiXuan.order = 'collect_num asc' : this.shaiXuan.order = 'collect_num desc'
				}
				console.log(this.shaiXuan);
				this.getList()
				// order
				// id desc
				// id asc
				// collect_num desc
				// collect_num asc
			},
			sendType(type) {
				this.activeTopType = type
				this.$emit('changeType', type)
				
			},
			async getGeniusList() {
				const list = await this.$api.TJGeniusList({
					page: this.geniusCurrent
				})
				this.geniusList = list.data
				console.log(list.data);
			},
			changeGenius() {
				if (this.geniusList.last_page == 1) return
				if (this.geniusCurrent >= this.geniusList.last_page) {
					this.geniusCurrent = 1
				} else {
					this.geniusCurrent++
				}
				this.getGeniusList()
			},
			handleChange(val) {
				console.log(val);
			},
			goto(url) {
				this.$router.push(url)
			},
		}
	}
</script>
<style scoped lang="less">
	/deep/.el-dialog__title {
		font-size: 20px;
		text-align: center;
		font-weight: bold;
	}

	.body-person-item {
		width: 151px;
		height: 270px;
		background: url('../../assets/images/personBg.png') no-repeat;
		background-position: center bottom;
		background-size: contain;
		margin-left: 50px;

		& p {
			margin-top: 6px;
			font-size: 18px;
		}

		&:first-child {
			margin-left: 0;
		}
	}

	.body-person {
		display: flex;
		align-items: center;
		text-align: center;
	}

	.page-last-body {
		padding: 40px 20px;
		box-sizing: border-box;
		width: 100%;
	}

	.page-last-top {
		display: flex;
		justify-content: space-between;
	}

	.huanyih {
		font-size: 18px;
		width: 110px;
		height: 40px;
		background: #F6F6F6;
		border: 1px solid #E5E5E5;
		text-align: center;
		cursor: pointer;
		line-height: 40px;
		margin-right: 20px;
	}

	.huanyih:hover {
		background: #0052D9;
		color: white;
	}

	.page-last-title {

		width: 120px;
		height: 40px;
		background: #0052D9;
		border-radius: 0px 20px 20px 0px;
		color: white;
		font-size: 22px;
		font-family: PingFang;
		font-weight: 800;
		color: #FFFFFF;
		line-height: 40px;
		text-align: center;
	}

	.page-last {
		padding-top: 30px;
		margin-top: 20px;
		width: 100%;
		height: 515px;
		background: #FFFFFF;
	}

	.body-right {
		&>div {
			cursor: pointer;
			margin-bottom: 10px;
			display: flex;
			align-items: center;
			justify-content: center;
			color: white;
			line-height: 50px;
			width: 200px;
			height: 50px;
			background: #0052D9;

			&>img {
				margin-right: 15px;
			}
		}
	}

	.body-mid-footer {
		display: flex;
		padding: 20px;
		box-sizing: border-box;
		height: 50px;
		background: #F6F6F6;
		justify-content: center;
		font-size: 18px;
		cursor: pointer;
		align-items: center;

		&>img {
			margin-left: 20px;
			width: 16px;
			height: 16px;
		}
	}

	.main-item {
		cursor: pointer;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		padding: 15px;
		box-sizing: border-box
	}

	.main-item-pic {
		width: 100px;
		height: 100px;
		border-radius: 50%;
		text-align: center;
		line-height: 100px;
		overflow: hidden;

	}

	.main-item-pic>img {
		width: 100%;
		height: 100%;
	}

	.body-mid-main {
		display: flex;
		flex-wrap: wrap;

		justify-content: flex-start;
	}

	.main-item {
		margin: 13px;
		margin-left: 18px;
		width: 180px;
		height: 210px;
		border: 1px solid #BFBFBF;
		transition: all 0.3s;
	}

	.main-item:hover {
		transform: scale(1.02);
		box-shadow: 0 0 10px #bababa;
	}

	.activeTop {
		color: white;
		background: #0052D9;
	}

	.mid-top-right {
		justify-content: space-around;
		display: flex;
		width: 580px;

		&>div {
			cursor: pointer;
			width: 100px;
			height: 38px;
			line-height: 38px;
			text-align: center;
			border: 1px solid #D2D2D2;
		}

		&>div:hover {
			color: white;
			background: #0052D9;
		}
	}

	.body-mid-top {
		margin-bottom: 15px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-top: 20px;

		&>.mid-top-left {
			font-size: 18px;
			width: 166px;
			justify-content: space-between;
			display: flex;
			align-items: center;

			&>div {
				cursor: pointer;
				display: flex;
				align-items: center;

				&>img {
					width: 15px;
					height: 15px;
				}
			}
		}
	}

	.body-mid {
		margin: 0 20px;
		width: 900px;
		box-sizing: border-box;
	}
</style>